<!-- Cycle and Barn selectors-->
<div></div>
<mat-toolbar>
  <mat-toolbar-row class="mat-toolbar__left">
    <ng-container>
      <div
        class="flex--column spacing--margin-right item-selector"
        *ngIf="(cycles$ | async)?.length > 0"
      >
        <mat-label class="text--small text--gray">
          {{ 'cycle-overview.cycle' | translate }}
        </mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="text--small"
          placeholder="{{ 'cycle-overview.placeholder' | translate }}"
          data-test="cycle-overview-detailed__cycle-selector"
          [(ngModel)]="selectedCycle"
          (selectionChange)="changeCycleSelection($event)"
        >
          <mat-option *ngFor="let cycle of cycles$ | async" [value]="cycle">
            {{ cycle.cycleNumber }}
            {{ !!cycle.cycleDate ? '(' + (cycle.cycleDate | agrDate: 'dd-MM-yyyy') : '' }}
            {{
              !!cycle.cycleEndDate
                ? '-' + (cycle.cycleEndDate | agrDate: 'dd-MM-yyyy' + ')')
                : !!cycle.cycleDate
                  ? ')'
                  : ''
            }}
          </mat-option>
        </mat-select>
      </div>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar>

<app-cycle-overview-detailed-panel
  *ngIf="selectedCycle && shouldShowObservationsPanel$ | async"
  panelSubject="daily-performance"
  [selectedCycle]="selectedCycle"
  [isMobile]="isMobile$ | async"
  [showAddButton]="false"
  data-test="panel--daily-performance"
>
  <div class="spacing--margin-half-bottom">
    <span class="float-left" *ngIf="selectedCycle?.dayOldChicks?.length > 0; else noRegistrations">
      <button
        mat-button
        (click)="openWeekRegistrations(selectedCycle)"
        data-test="panel--daily-performance__edit-current-week"
      >
        <mat-icon>create</mat-icon>
        {{ 'cycle-overview.panel.edit-current-week' | translate }}
      </button>
    </span>
    <ng-template #noRegistrations>
      <div class="text--small text--bold" data-test="panel--daily-performance__empty">
        {{ 'cycle-overview.daily-performance-empty.title' | translate }}
      </div>
      <div class="text--small text--gray">
        {{ 'cycle-overview.daily-performance-empty.description' | translate }}
      </div>
    </ng-template>
  </div>
  <agr-extended-notification
    *ngIf="showCycleStartInFutureWarning"
    notificationType="warning"
    [title]="'cycle-overview.cycle-start-in-future-warning-title' | translate"
    [message]="'cycle-overview.cycle-start-in-future-warning-description' | translate"
  >
  </agr-extended-notification>
</app-cycle-overview-detailed-panel>
